import { render, staticRenderFns } from "./tradingOrder.vue?vue&type=template&id=578108fb"
import script from "./tradingOrder.vue?vue&type=script&lang=js"
export * from "./tradingOrder.vue?vue&type=script&lang=js"
import style0 from "./tradingOrder.vue?vue&type=style&index=0&id=578108fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports